export default "__VITE_ASSET__BUuhK0Uv__"